<template>
    <div>
        <hp5-heading size-selection="md" tag-selection="h3" v-if="clinic.locationUrl">
            <hp5-link-text-basic size="md">
                <a  :href="clinic.locationUrl" target="_blank">{{ clinic.name }}</a>
            </hp5-link-text-basic>
        </hp5-heading>
        <hp5-heading size-selection="md" tag-selection="h3" v-else>{{ clinic.name }}</hp5-heading>
        <hp5-spacing-vertical xs="xs"></hp5-spacing-vertical>
    </div>
</template>

<script setup>

    const props = defineProps({
        clinic: Object
    })

</script>

<style scoped>

    hp5-link-text-basic .hp-link-text-basic {
        color: var(--color-text-base);
        text-decoration: none;
        font-size: var(--text-heading-pixels-md);
    }

</style>